module.exports = __webpack_public_path__ + "static/media/Apple iPad Mini Silver.ecde4de1.png";